import { FilePond } from "react-filepond";
import { ActualFileObject, FilePondFile } from "filepond";
import { t } from "i18next";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Carousel, Modal } from "react-bootstrap";
import { RemoveImageButton } from "../../../shared/components/RemoveImageButton";
import { CustomImageHandler } from "../../../shared/components/CustomImageHandler";
import { ConfirmDelete } from "../../../shared/components/ConfirmDelete";
import { IPicture } from "../../../model/shared/IPicture";
import { ProductsService } from "../service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { IProductsList, IProductVariation } from "../dto/IProducts";
import Select, { SingleValue } from "react-select";
import {
  ICategoryChildren,
  ICategoryDTO,
} from "../../category/values/dto/ICategory";
import { useDispatch, useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { themeSelect } from "../../../shared/components/Select2";
import changeLocationSlice from "../../../store/category/changeLocation";
import { IBrand } from "../../brand/dto/IBrand";
import { ContentEditableEvent } from "react-simple-wysiwyg";
import { getWebsiteTranslation } from "../../../shared/functions/Functions";
import { BrandService } from "../../brand/service";
import { ContentViewSide } from "../content/components/ContentViewSide";
import ProductVariation from "./ProductVariation";
import { Pagination } from "../../../shared/paginations/Paginations";
import VariationUpdateForm from "../content/components/VariationUpdateForm";
import { WorkflowService } from "../../workflow/service";
import { ContentActions } from "../content/components/ContentActions";
import { BlockService } from "../../block/service";
import { DocumentBlockService } from "../../blockDocument/service";
import { CategoryServicee } from "../../../store/category/categoryService";
import categorySlice from "../../../store/category/categoryRedux";
interface Props {
  currentProduct: any;
  setCurrentProduct: any;
  usedLanguagesArray?: any;
}
const variationInitial = {
  title: null,
  lang: "",
  bullets: "",
  introText: "",
  description: "",
  subtitle: "",
  blocks: {},
} as any;
//setCurrentProduct moram rijesiti sa baseDataProduct svuda
export const PreviewProudctModalBaseData = ({
  currentProduct,
  setCurrentProduct,
  usedLanguagesArray,
}: Props) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState<ActualFileObject[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [variationPagination, setVariationPagination] = useState({
    page: 1,
    perPage: 10,
  });
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [allBlocks, setAllBlocks] = useState([] as any);
  const handlePages = (updatePage: number) => {
    setVariationPagination({ ...variationPagination, page: updatePage });
    setPage(updatePage);
  };
  const mainLangBlock = {
    en: "Data sheet",
    de: "Datenblatt",
    fr: "Fiche technique",
    it: "Scheda tecnica",
  };
  const [imgFancyBox, setImgFancyBox] = useState<string>("");
  const [productStaticts, setProductStaticts] = useState({} as any);
  const [certainBlocks, setCertainBlocks] = useState([]);
  const [documentBlockList, setDocumentBlockList] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedImage, setSelectedImage] = useState<IPicture>();
  const [brandList, setBrandList] = useState<IBrand[]>([]);
  const [currentVariation, setCurrentVariation] = useState<IProductVariation>(
    variationInitial as any
  );
  const [activeTabSecondView, setActiveTabSecondView] = useState(undefined);
  const [currentBlock, setCurrentBlock] = useState({ id: null, name: "" });
  const { websiteEnum } = useSelector((state: IAllStates) => state.enums);
  const [showDialog, setShowDialog] = useState(false);
  const [detectedChange, setDetectedChange] = useState(false);
  const dialogCacnel = () => {
    setShowDialog((prev: boolean) => !prev);
  };
  const dialogConfirm = () => {
    setDetectedChange((prev: boolean) => !prev);
    handleCloseConfirm();
  };
  const handleCloseConfirm = () => {
    setShowVariationModal((prev: boolean) => !prev);
    setCurrentVariation(variationInitial as any);
    setShowDialog((prev: boolean) => !prev);
  };
  const currentLanguage = localStorage.getItem("language");
  const [activeTab, setActiveTab] = useState(
    window.location.pathname?.includes("workflow/step9/")
      ? usedLanguagesArray[0]
      : currentLanguage ?? "de"
  );
  const { accessRights, roles } = useSelector(
    (state: IAllStates) => state.auth
  );
  const [triggerVariationUpdate, setTriggerVariationUpdate] = useState(false);
  const [currentVariationTranslation, setCurrentVariationTranslation] =
    useState<IProductVariation>();
  const [variationList, setVariationList] = useState<IProductVariation[]>([]);
  const { translationLanguageEnum } = useSelector(
    (state: IAllStates) => state.enums
  );
  const [open, setOpen] = useState(false);
  const [showVariationModal, setShowVariationModal] = useState(false);
  const userClientDashboard = accessRights?.includes(
    "client_dashboard_can_view"
  );
  const isManager = roles?.includes("ROLE_MANAGER");
  const isAdmin = roles?.includes("ROLE_ADMIN");
  const isCompanyAdmin = roles?.includes("ROLE_COMPANY_ADMIN");
  const showCrawlerUrl = accessRights?.includes(
    "product_base_data_crawler_can_view"
  );
  const categories = useSelector((state: IAllStates) => state.category as any);
  const [selectedMainCategory, setSelectedMainCategory] = useState<
    ICategoryChildren[]
  >([]);
  const [showModalBlock, setShowModalBlock] = useState(false);
  const [blockIndex, setBlockIndex] = useState(null);
  const [blockLanguage, setBlockLanguage] = useState("");
  const [triggerMainCategoryClear, setTriggerMainCategoryClear] =
    useState(false);
  const handleCloseVariation = () => {
    setShowVariationModal((prev: boolean) => !prev);
    setCurrentVariation(variationInitial as any);
  };
  function getCleanImageUrl(url: string) {
    try {
      const urlParts = url.split("https://");
      if (urlParts.length > 2) {
        return "https://" + urlParts.slice(2).join("https://");
      }
      return url;
    } catch (error) {
      console.error("Invalid URL:", error);
      return "";
    }
  }
  const toggle = () => {
    setOpen((prev: boolean) => !prev);
  };
  const handleClose = () => {
    if (detectedChange) {
      setShowDialog(true);
    } else {
      setShowVariationModal(false);
      setCurrentVariation(variationInitial as any);
    }
  };
  const handleSelectBlock = (
    selectedSingle: SingleValue<{ label: string; value: any }>
  ) => {
    setCurrentBlock({
      id: selectedSingle?.value as any,
      name: selectedSingle?.label as string,
    });
  };
  const changeHandlerMulti = (
    e: React.ChangeEvent<HTMLInputElement>,
    type?: string,
    index?: number
  ) => {
    const { name, value } = e.target;
    const lang = activeTab as unknown as string;

    setCurrentProduct((prevState: any) => {
      const updatedTranslation = { ...prevState.translation };

      // Ako je u pitanju array (links, photos, videos, documents)
      if (type && typeof index === "number") {
        const updatedArray = [...(updatedTranslation[lang]?.[type] || [])];

        if (type === "documents") {
          updatedArray[index] = { ...updatedArray[index], link: value };
        } else {
          updatedArray[index] = value;
        }

        return {
          ...prevState,
          translation: {
            ...updatedTranslation,
            [lang]: {
              ...updatedTranslation[lang],
              [type]: updatedArray,
            },
          },
        };
      }

      // Ako je u pitanju običan string (title, subtitle)
      return {
        ...prevState,
        translation: {
          ...updatedTranslation,
          [lang]: {
            ...updatedTranslation[lang],
            [name]: value,
          },
        },
      };
    });
  };
  const openInNewTab = (url: string) => {
    if (url) {
      const newWindow = window.open(`${url}`, "_blank", "noreferrer");
      if (newWindow) newWindow.opener = null;
    } else {
      ErrorToast({
        response: {
          data: {
            error: "Bad Request",
            message: ["Field is empty"],
            statusCode: 400,
          },
        },
      });
    }
  };
  useEffect(() => {
    BlockService.getAllBlocks({
      page: 1,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        setAllBlocks(data as any);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  const handleSubmit = (
    event: React.FormEvent,
    language: string,
    checkNext = false
  ) => {};
  const changeHandler = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | ContentEditableEvent
    >
  ) => {
    // @ts-ignore
    const { value, name } = event.target;
    dispatch(changeLocationSlice.actions.setChangeLocation(true));
    setCurrentProduct((prev: any) => ({ ...prev, [name]: value }));
  };
  const handleShow = () => {
    setShowVariationModal(true);
    setCertainBlocks(currentProduct?.block as any);
  };
  const deleteImageHandler = () => {
    selectedImage?.id &&
      ProductsService.deleteImageById(selectedImage?.id)
        .then((response) => {
          if (response === "") {
            //   navigate(0);
            SuccessToast(
              `${t("toasts.successfully_deleted")} ${
                selectedImage?.file?.nameOriginal
              }`
            );
          }
        })
        .catch((error) => ErrorToast(error));
  };

  const getAllVariations = ({
    variationPagination,
    id,
    setVariationList,
    setTotalPages,
    setPage,
    setVariationPagination,
  }: any) => {
    ProductsService.getAllVariations({
      ...variationPagination,
      product: Number(id),
    })
      .then((response) => {
        if (
          variationPagination?.page > 1 &&
          variationPagination?.page > response?.totalPages
        ) {
          setPage(response?.totalPages);
          setVariationPagination({
            ...variationPagination,
            page: response?.totalPages,
          });
        }
        setVariationList(response.data);
        setTotalPages(Math.ceil(response?.count / response?.perPage));
      })
      .catch((error) => ErrorToast(error));
  };
  const handleSelectMainCategory = (
    selectedSingle: SingleValue<{ label: string; value: number }>,
    inputKey: string
  ) => {
    dispatch(changeLocationSlice.actions.setChangeLocation(true));
    setCurrentProduct((prev: any) => ({
      ...prev,
      [inputKey]: selectedSingle?.value,
    }));
  };
  useEffect(() => {
    CategoryServicee.getAllCategories()
      .then((data) => {
        dispatch(categorySlice.actions.setCategory(data));
      })
      .catch((error) => ErrorToast(error));
  }, []);
  useEffect(() => {
    BrandService.getAllBrands({ page: 10, perPage: 0 })
      .then((response) => {
        const { data } = response;
        setBrandList(data);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  function handleSelectSingle2(
    selectedSingle: SingleValue<{ label: string; value: number }>
  ) {
    setTriggerMainCategoryClear((prev: boolean) => !prev);
    const selected = categories?.find(
      (category: ICategoryDTO) => category?.id === selectedSingle?.value
    )?.children;
    selected && setSelectedMainCategory(selected);
    setCurrentProduct((prev: any) => ({
      ...prev,
      category: null,
    }));
  }
  const accessUserClientDashboard = () => {
    if (userClientDashboard && !isAdmin && !isCompanyAdmin && !isManager) {
      return false;
    } else {
      return true;
    }
  };
  function handleSelectSingle(
    selectedSingle: SingleValue<{ label: string; value: number }>
  ) {
    setCurrentProduct((prev: any) => ({
      ...prev,
      website: selectedSingle?.value,
    }));
  }
  const changeActiveTab = (lng: string) => {
    setActiveTab(lng);
  };
  const handleAddField = (field: string) => {
    setCurrentProduct((prev: any) => {
      const updated = { ...prev };
      const list = updated.translation?.[activeTab]?.[field] ?? [];

      const newItem = field === "documents" ? { link: "" } : "";

      updated.translation[activeTab][field] = [...list, newItem];
      return updated;
    });
  };
  const addFormFieldsDocument = (e: any, lang: string, index: number) => {
    e.preventDefault();

    setShowModalBlock((prev: boolean) => !prev);
    setBlockIndex(index as any);
    setBlockLanguage(lang);
  };
  const handleRemoveField = (field: string, index: number) => {
    setCurrentProduct((prev: any) => {
      const updated = { ...prev };
      let list = updated.translation?.[activeTab]?.[field] ?? [];

      list.splice(index, 1);
      updated.translation[activeTab][field] = [...list];

      return updated;
    });
  };
  const EditorWithContent = useCallback(() => {
    return (
      <MainCategoryFilter
        selectedMainCategory={selectedMainCategory}
        t={t}
        //   disabled={disabled}
        currentProduct={currentProduct}
        handleSelectMainCategory={handleSelectMainCategory}
        //   accessUserClientDashboard={accessUserClientDashboard}
      />
    );
  }, [
    triggerMainCategoryClear,
    currentProduct?.id,
    selectedMainCategory,
    // (currentProduct as any)?.category?.parents,
  ]);
  useEffect(() => {
    if (currentProduct?.id) {
      const parentId = currentProduct?.category?.parents?.find(
        (category: { level: number }) => category.level === 1
      )?.id;

      const correctCategory = categories.find(
        (category: { id: number }) => category.id === parentId
      );
      setSelectedMainCategory(correctCategory?.children);
    }
    getAllVariations({
      variationPagination: variationPagination,
      id: currentProduct?.id,
      setVariationList: setVariationList,
      setTotalPages: setTotalPages,
      setPage: setPage,
      setVariationPagination: setVariationPagination,
    });
  }, [currentProduct?.id, triggerVariationUpdate]);
  const handleSave = () => {
    const newArray = {
      block: currentBlock?.id,
      blockName: currentBlock?.name,
      link: "",
    };

    setShowModalBlock((prev: boolean) => !prev);

    setCurrentProduct((prevData: any) => {
      const existingLangData = prevData?.translation?.[blockLanguage] || {};
      const existingDocuments = existingLangData.documents || [];

      return {
        ...prevData,
        translation: {
          ...prevData.translation,
          [blockLanguage]: {
            ...existingLangData,
            documents: [...existingDocuments, newArray],
          },
        },
      };
    });
  };
  useEffect(() => {
    DocumentBlockService.getAllBlocks({ page: 10, perPage: 0 })
      .then((response) => {
        const { data } = response;
        setDocumentBlockList(data);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  console.log(usedLanguagesArray, "usedLanguagesArray");

  return (
    <div className="row">
      <div className="col-md-4">
        <div className="" style={{ maxHeight: "290px" }}>
          <div className="h-100">
            <FilePond
              files={files}
              allowReorder={true}
              allowMultiple={true}
              acceptedFileTypes={["image/*"]}
              onupdatefiles={(filesArr: FilePondFile[]) => {
                setFiles(filesArr?.map((fileItem) => fileItem?.file));
              }}
              labelIdle={`${t("products.drag_and_drop")}`}
            />
            {true && (
              <>
                <Carousel style={{ maxHeight: "170px" }}>
                  {(currentProduct as IProductsList)?.productPictures?.map(
                    (productImage) => (
                      <Carousel.Item
                        key={productImage?.id}
                        className="position-relative text-center"
                        style={{ maxHeight: "170px" }}
                      >
                        <RemoveImageButton
                          onClick={() => {
                            setOpenModal(true);
                            setSelectedImage(productImage);
                          }}
                        />
                        <CustomImageHandler
                          path={`${productImage?.path}`}
                          classes="figure-img img-fluid rounded"
                          alt="Product"
                        />
                      </Carousel.Item>
                    )
                  )}
                </Carousel>
              </>
            )}
          </div>
        </div>
        <ConfirmDelete
          show={openModal}
          setShow={setOpenModal}
          itemName={selectedImage?.file?.nameOriginal}
          deleteHandler={deleteImageHandler}
          selectedProduct={selectedImage}
        />
      </div>
      <div className="col-md-8">
        {" "}
        <div className="">
          <ul className="nav nav-tabs-custom rounded card-header-tabs border-bottom-0 padding-tab">
            {(usedLanguagesArray?.length > 0
              ? usedLanguagesArray
              : translationLanguageEnum
            )?.map((language: string, index: number) => {
              return (
                <li
                  className="nav-item custom-basis"
                  key={index}
                  onClick={() => changeActiveTab(language)}
                >
                  <a
                    className={`nav-link ${
                      activeTab === language ? "active" : ""
                    } nav-link-view`}
                    data-bs-toggle="tab"
                    href={`#${language}`}
                    role="tab"
                    aria-selected={language === currentLanguage}
                  >
                    <img
                      src={`/images/flags/${language}.svg`}
                      alt="country-image"
                      className="me-2 rounded"
                      height="18"
                    />
                    <span
                      className={
                        activeTab === language ? "text-primary" : "text-dark"
                      }
                    >
                      {language.toUpperCase()}
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>

          <div className="tab-content preview-overflow">
            {translationLanguageEnum?.map((language, index) => {
              return (
                <div
                  key={index}
                  className={`tab-pane  ${
                    activeTab === language ? "active" : ""
                  }`}
                  id={language}
                  role="tabpanel"
                >
                  <div className="mt-3">
                    <div className="d-flex justify-content-center align-items-center my-2">
                      <label htmlFor="title" className="preview-label">
                        {t("global.title")}:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        onChange={(e) => changeHandlerMulti(e, "title")}
                        value={
                          currentProduct?.translation?.[
                            activeTab as unknown as string
                          ]?.title
                        }
                      />
                    </div>
                    <div className="d-flex justify-content-center align-items-center my-2">
                      <label htmlFor="subtitle" className="preview-label">
                        {t("mapping.subtitle")}:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="subtitle"
                        onChange={(e) => changeHandlerMulti(e, "subtitle")}
                        value={
                          currentProduct?.translation?.[
                            activeTab as unknown as string
                          ]?.subtitle
                        }
                      />
                    </div>
                    <div className="d-flex justify-content-center align-items-center my-2">
                      <label htmlFor="links" className="preview-label">
                        {t("mapping.links")}:
                      </label>
                      <div className="d-flex flex-column w-100">
                        {currentProduct?.translation?.[activeTab]?.links?.map(
                          (item: any, idx: number) => (
                            <div className="input-group mb-1" key={idx}>
                              <input
                                type="text"
                                className="form-control"
                                name="links"
                                onChange={(e) =>
                                  changeHandlerMulti(e, "links", idx)
                                }
                                value={item}
                              />
                              <div className="input-group-append d-flex align-items-center mx-1">
                                {idx === 0 ? (
                                  // <button
                                  //   className="btn btn-success"
                                  //   type="button"

                                  // >
                                  //   +
                                  // </button>
                                  <span
                                    style={{
                                      color: "green",
                                      fontSize: "18px",
                                    }}
                                    onClick={() => handleAddField("links")}
                                    className="cursor-pointer"
                                  >
                                    <i className="ri-add-circle-fill me-1"></i>
                                  </span>
                                ) : (
                                  // <button
                                  //   className="btn btn-danger"
                                  //   type="button"
                                  //   onClick={() =>
                                  //     handleRemoveField("links", idx)
                                  //   }
                                  // >
                                  //   🗑
                                  // </button>
                                  <span
                                    className="cursor-pointer"
                                    style={{
                                      color: "red",
                                      fontSize: "18px",
                                    }}
                                    onClick={() =>
                                      handleRemoveField("links", idx)
                                    }
                                  >
                                    <i className="ri-delete-bin-fill me-1"></i>
                                  </span>
                                )}
                                <span
                                  onClick={() => {
                                    openInNewTab(item);
                                  }}
                                  className="cursor-pointer"
                                  style={{
                                    color: "#3577f1",
                                    fontSize: "18px",
                                  }}
                                >
                                  <i className="ri-eye-fill ms-1"></i>
                                </span>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center my-2">
                      <label htmlFor="photos" className="preview-label">
                        {t("mapping.photos")}:
                      </label>
                      <div className="d-flex flex-column w-100">
                        {currentProduct?.translation?.[activeTab]?.photos?.map(
                          (item: any, idx: number) => (
                            <div className="input-group mb-1" key={idx}>
                              <input
                                type="text"
                                className="form-control"
                                name="photos"
                                onChange={(e) =>
                                  changeHandlerMulti(e, "photos", idx)
                                }
                                value={item}
                              />
                              <div className="input-group-append  d-flex align-items-center mx-1">
                                {idx === 0 ? (
                                  // <button
                                  //   className="btn btn-success"
                                  //   type="button"
                                  //   onClick={() => handleAddField("photos")}
                                  // >
                                  //   +
                                  // </button>
                                  <span
                                    style={{
                                      color: "green",
                                      fontSize: "18px",
                                    }}
                                    onClick={() => handleAddField("photos")}
                                    className="cursor-pointer"
                                  >
                                    <i className="ri-add-circle-fill me-1"></i>
                                  </span>
                                ) : (
                                  // <button
                                  //   className="btn btn-danger"
                                  //   type="button"
                                  //   onClick={() =>
                                  //     handleRemoveField("photos", idx)
                                  //   }
                                  // >
                                  //   🗑
                                  // </button>
                                  <span
                                    className="cursor-pointer"
                                    style={{
                                      color: "red",
                                      fontSize: "18px",
                                    }}
                                    onClick={() =>
                                      handleRemoveField("photos", idx)
                                    }
                                  >
                                    <i className="ri-delete-bin-fill me-1"></i>
                                  </span>
                                )}
                                <span
                                  onClick={() => {
                                    setImgFancyBox(
                                      getCleanImageUrl(
                                        item as unknown as string
                                      )
                                    );
                                    item
                                      ? toggle()
                                      : ErrorToast({
                                          response: {
                                            data: {
                                              error: "Bad Request",
                                              message: ["Field is empty"],
                                              statusCode: 400,
                                            },
                                          },
                                        });
                                  }}
                                  className="cursor-pointer"
                                  style={{
                                    color: "#3577f1",
                                    fontSize: "18px",
                                  }}
                                >
                                  <i className="ri-eye-fill ms-1"></i>
                                </span>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center my-2">
                      <label htmlFor="documents" className="preview-label">
                        {t("mapping.documents")}:
                      </label>
                      <div className="d-flex flex-column w-100">
                        {currentProduct?.translation?.[
                          activeTab as unknown as string
                        ]?.documents?.map((item: any, idx: number) => (
                          <div className="d-flex flex-column justify-content-start">
                            <span className="text-start fw-500">
                              {idx === 0
                                ? (mainLangBlock as any)?.[language]
                                : item?.blockName}
                            </span>
                            <div className="d-flex">
                              <input
                                type="text"
                                className={`form-control ${
                                  currentProduct?.translation?.[activeTab]
                                    ?.documents?.length > 1 &&
                                  idx <
                                    currentProduct?.translation?.[activeTab]
                                      ?.documents?.length -
                                      1 &&
                                  "mb-1"
                                }`}
                                name="documents"
                                onChange={(e) =>
                                  changeHandlerMulti(e, "documents", idx)
                                }
                                value={item?.link}
                              />
                              <div className="input-group-append d-flex align-items-center mx-1">
                                {idx === 0 ? (
                                  // <button
                                  //   className="btn btn-success"
                                  //   type="button"
                                  //   onClick={(e) =>
                                  //     addFormFieldsDocument(e, activeTab, idx)
                                  //   }
                                  // >
                                  //   +
                                  // </button>
                                  <span
                                    style={{
                                      color: "green",
                                      fontSize: "18px",
                                    }}
                                    onClick={(e) =>
                                      addFormFieldsDocument(e, activeTab, idx)
                                    }
                                    className="cursor-pointer"
                                  >
                                    <i className="ri-add-circle-fill me-1"></i>
                                  </span>
                                ) : (
                                  // <button
                                  //   className="btn btn-danger"
                                  //   type="button"
                                  //   onClick={() =>
                                  //     handleRemoveField("documents", idx)
                                  //   }
                                  // >
                                  //   🗑
                                  // </button>
                                  <span
                                    className="cursor-pointer"
                                    style={{
                                      color: "red",
                                      fontSize: "18px",
                                    }}
                                    onClick={() =>
                                      handleRemoveField("documents", idx)
                                    }
                                  >
                                    <i className="ri-delete-bin-fill me-1"></i>
                                  </span>
                                )}
                                <span
                                  onClick={() => {
                                    openInNewTab(item?.link);
                                  }}
                                  className="cursor-pointer"
                                  style={{
                                    color: "#3577f1",
                                    fontSize: "18px",
                                  }}
                                >
                                  <i className="ri-eye-fill ms-1"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center my-2">
                      <label htmlFor="videos" className="preview-label">
                        {t("mapping.videos")}:
                      </label>
                      <div className="d-flex flex-column w-100">
                        {currentProduct?.translation?.[activeTab]?.videos?.map(
                          (item: any, idx: number) => (
                            <div
                              className="input-group mb-1 d-flex align-items-center"
                              key={idx}
                            >
                              <input
                                type="text"
                                className="form-control"
                                name="videos"
                                onChange={(e) =>
                                  changeHandlerMulti(e, "videos", idx)
                                }
                                value={item}
                              />
                              <div className="input-group-append mx-1">
                                {idx === 0 ? (
                                  // <button
                                  //   className="btn btn-success"
                                  //   type="button"
                                  //   onClick={() => handleAddField("videos")}
                                  // >
                                  //   +
                                  // </button>
                                  <span
                                    style={{
                                      color: "green",
                                      fontSize: "18px",
                                    }}
                                    onClick={() => handleAddField("videos")}
                                    className="cursor-pointer"
                                  >
                                    <i className="ri-add-circle-fill me-1"></i>
                                  </span>
                                ) : (
                                  // <button
                                  //   className="btn btn-danger"
                                  //   type="button"
                                  //   onClick={() =>
                                  //     handleRemoveField("videos", idx)
                                  //   }
                                  // >
                                  //   🗑
                                  // </button>
                                  <span
                                    className="cursor-pointer"
                                    style={{
                                      color: "red",
                                      fontSize: "18px",
                                    }}
                                    onClick={() =>
                                      handleRemoveField("videos", idx)
                                    }
                                  >
                                    <i className="ri-delete-bin-fill me-1"></i>
                                  </span>
                                )}
                                <span
                                  onClick={() => {
                                    openInNewTab(item);
                                  }}
                                  className="cursor-pointer"
                                  style={{
                                    color: "#3577f1",
                                    fontSize: "18px",
                                  }}
                                >
                                  <i className="ri-eye-fill ms-1"></i>
                                </span>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Modal show={open} toggle={toggle}>
        <button type="button" className="btn fs-3" onClick={toggle}>
          ×
        </button>
        <img className="d-block w-100" src={imgFancyBox} alt="Image One" />
      </Modal>
      <Modal show={showModalBlock} size="xl" style={{ height: "500px" }}>
        <Modal.Body
          className="d-flex align-items-center flex-column"
          style={{ height: "420px" }}
        >
          <label htmlFor="category" className="">
            {t(`mapping.documents_block`)}
          </label>
          <Select
            className="react-select-field w-400"
            theme={themeSelect}
            options={documentBlockList?.map((brand) => ({
              label: brand?.name ?? "-",
              value: brand?.id,
            }))}
            onChange={(e) => {
              handleSelectBlock(
                e as SingleValue<{ label: string; value: number }>
              );
            }}
            key={currentProduct?.id}
          />
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-center">
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              handleSave();
            }}
          >
            {t(`global.save`)}
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="col-md-12">
        <div className="row">
          <div className={`col-md-3 my-1`}>
            <label htmlFor="eanCode">{t("products.ean_code")}</label>
            <input
              //   disabled={!accessUserClientDashboard()}
              type="text"
              className="form-control"
              name="eanCode"
              onChange={changeHandler}
              value={currentProduct?.eanCode}
              placeholder={t("products.enter_ean_code")}
            />
          </div>
          <div className="col-md-3 my-1">
            <label htmlFor="articleNumber">{t("products.articleNumber")}</label>
            <input
              //   disabled={!accessUserClientDashboard()}
              type="text"
              className="form-control"
              name="articleNumber"
              onChange={changeHandler}
              value={currentProduct?.articleNumber}
              placeholder={t("products.enter_articleNumber")}
            />
          </div>
          <div className="col-md-3 my-1">
            <label htmlFor="sapId">{t("products.sapId")}</label>
            <input
              //   disabled={!accessUserClientDashboard()}
              type="text"
              className="form-control"
              name="sapId"
              onChange={changeHandler}
              value={currentProduct?.sapId}
              placeholder={t("products.enter_sap_id")}
            />
          </div>
          <div className="col-md-3 my-1">
            <label htmlFor="pharmaCode">{t("products.pharmaCode")}</label>
            <input
              type="text"
              //   disabled={!accessUserClientDashboard()}
              className="form-control"
              name="pharmaCode"
              onChange={changeHandler}
              value={currentProduct?.pharmaCode}
              placeholder={t("products.enter_pharma_code")}
            />
          </div>
          <div
            className={`col-md-${!!selectedMainCategory?.length ? 4 : 6} my-1`}
          >
            <label htmlFor="category" className="required-field">
              {t("products.select_main_category")}
            </label>
            <Select
              className="react-select-field"
              //   isDisabled={
              //     (disabled() as unknown as boolean | undefined) ||
              //     !accessUserClientDashboard()
              //   }
              theme={themeSelect}
              options={categories
                ?.filter(
                  (category: { children: [] }) => !!category?.children?.length
                )
                ?.map((cat: { id: any; title: any }) => ({
                  value: cat?.id,
                  label: cat?.title ?? "-",
                }))}
              key={currentProduct?.id}
              defaultValue={
                (currentProduct as any)?.category?.parents && {
                  label: (currentProduct as any)?.category?.parents?.find(
                    (parent: { level: number }) => parent?.level === 1
                  )?.title,
                  value: (currentProduct as any)?.category?.parents?.find(
                    (parent: { level: number }) => parent?.level === 1
                  )?.id,
                }
              }
              onChange={(e) => {
                handleSelectSingle2(e);
              }}
            />
          </div>

          {!!selectedMainCategory?.length && <EditorWithContent />}

          <div
            className={`col-md-${!!selectedMainCategory?.length ? 4 : 6} my-1`}
          >
            <label htmlFor="category" className="required-field">
              {t("products.brand")}
            </label>
            <Select
              className="react-select-field"
              theme={themeSelect}
              //   isDisabled={!accessUserClientDashboard()}
              options={brandList?.map((brand) => ({
                label: brand?.name ?? "-",
                value: brand?.id,
              }))}
              defaultValue={
                (currentProduct as IProductsList)?.brand?.id && {
                  label: (currentProduct as IProductsList)?.brand?.name,
                  value: (currentProduct as IProductsList)?.brand?.id,
                }
              }
              onChange={(e) => {
                handleSelectMainCategory(
                  e as SingleValue<{ label: string; value: number }>,
                  "brand"
                );
              }}
              key={currentProduct?.id}
            />
          </div>
          {
            //   isImported || isCrawled
            false ? (
              ""
            ) : (
              <>
                <div className={`col-md-${showCrawlerUrl ? "4" : "6"} my-1`}>
                  <label htmlFor="sourceUrl">{`${t(
                    "products.source_url"
                  )}`}</label>
                  <input
                    type="text"
                    name="sourceUrl"
                    required
                    // disabled={!accessUserClientDashboard()}
                    value={(currentProduct as any)?.sourceUrl}
                    onChange={changeHandler}
                    className="form-control"
                  />
                </div>
                <div className={`col-md-${showCrawlerUrl ? "4" : "6"} my-1`}>
                  <label htmlFor="website">{`${t("crawlers.website")}`}</label>
                  <Select
                    className="react-select-field"
                    options={websiteEnum?.map((website) => ({
                      value: website,
                      label: getWebsiteTranslation(website, t),
                    }))}
                    isDisabled={!accessUserClientDashboard()}
                    theme={themeSelect}
                    onChange={(e) => {
                      handleSelectSingle(e);
                    }}
                    defaultValue={
                      currentProduct?.website && {
                        label: getWebsiteTranslation(
                          currentProduct?.website,
                          t
                        ),
                        value: currentProduct?.website,
                      }
                    }
                    key={currentProduct?.id}
                  />
                </div>
                {
                  //   showCrawlerUrl
                  true && (
                    <div className={`col-md-4 my-1`}>
                      <label htmlFor="url">{`${t(
                        "products.crawlerUrl"
                      )}`}</label>
                      <input
                        type="text"
                        name="crawlerUrl"
                        required
                        disabled={!accessUserClientDashboard()}
                        value={currentProduct?.crawlerUrl}
                        onChange={changeHandler}
                        className="form-control"
                      />
                    </div>
                  )
                }
              </>
            )
          }
        </div>
      </div>
      {activeTab && (
        <div className="row">
          <ContentActions
            key={activeTab}
            // productStaticts={productStaticts}
            allBlocks={allBlocks}
            selectedProductId={currentProduct?.id}
            setTriggerUpdate={setTriggerUpdate}
            currentProduct={currentProduct as IProductsList}
            setCurrentProduct={setCurrentProduct}
            changeHandler={changeHandler}
            handleSubmit={handleSubmit}
            isTranslator={false}
            previewActiveTab={activeTab}
            activeTabSecondView={activeTabSecondView}
            setActiveTabSecondView={setActiveTabSecondView}
          />
        </div>
      )}
    </div>
  );
};
const MainCategoryFilter = ({
  selectedMainCategory,
  t,
  disabled,
  currentProduct,
  handleSelectMainCategory,
  accessUserClientDashboard,
}: any) => {
  return (
    <>
      <div className="col-md-4 my-1">
        <label htmlFor="category" className="required-field">
          {t("products.select_category")}
        </label>
        <Select
          className="react-select-field"
          //   isDisabled={
          //     (disabled() as unknown as boolean | undefined) ||
          //     !accessUserClientDashboard()
          //   }
          theme={themeSelect}
          options={selectedMainCategory?.map((mainCat: any) => ({
            label: mainCat?.title ?? "-",
            options: mainCat?.children?.map((subCat: any) => ({
              label: subCat?.title ?? "-",
              value: subCat?.id,
            })),
          }))}
          defaultValue={
            (currentProduct as any)?.category?.id && {
              label: (currentProduct as any)?.category?.title,
              value: (currentProduct as any)?.category?.id,
            }
          }
          key={currentProduct?.id}
          onChange={(e) => {
            handleSelectMainCategory(
              e as SingleValue<{ label: string; value: number }>,
              "category"
            );
          }}
        />
        {currentProduct?.id && (
          //  accessUserClientDashboard() &&
          <div
            className="alert alert-warning alert-borderless mt-2 mb-0 p-0"
            role="alert"
          >
            <p
              className="mb-0"
              dangerouslySetInnerHTML={{
                __html: t(`products.affect_attributes`),
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};
